<template>
  <section class="skills section" id="skills">
    <h2 class="section-title">{{ $t('product.title') }}</h2>

    <div class="skills-container bd-grid">
      <div class="skills-box">
        <h3 class="skills-subtitle">{{ $t('product.how') }}</h3>

        <span
          v-for="(step, i) in $tm('product.steps')"
          :key="'s'+i"
          class="skills-name"
        >{{ step }}</span>

        <h3 class="skills-subtitle" style="margin-top: 1rem;">{{ $t('product.stackTitle') }}</h3>

        <span
          v-for="(line, i) in $tm('product.stack')"
          :key="'t'+i"
          class="skills-name"
        >{{ line }}</span>
      </div>

      <div class="skills-img">
        <img :src="require('@/assets/SkillsImage.png')" alt="Arquitectura del producto" class="skills-img">
      </div>
    </div>
  </section>
</template>

<script>
import sr from '@/scrollreveal.js';

export default {
  name: 'SkillsSection',
  mounted() {
    sr.reveal('.skills-subtitle', {});
    sr.reveal('.skills-name', { distance: '20px', delay: 50, interval: 80 });
    sr.reveal('.skills-img', { delay: 300 });
  }
};
</script>

<style src="@/styles/Skills-Section.css"></style>
